import { JSX, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { GridItem } from "../../Layout/Grid/GridItem";
import { GridContainer } from "../../Layout/Grid/GridContainer";

export class LeftButtons extends BaseComponent<ILeftButtonsProps, ILeftButtonsState>
{
    public render(): JSX.Element
    {
        const children = (this.props.children ? (Array.isArray(this.props.children) ? this.props.children : [this.props.children]) : []);

        return (
            <GridItem compact={12} expanded={this.props.fullWidth ? 12 : 6}>
                <GridContainer spacing={2}>
                    {children.filter(i => !!i).map(button => (
                        <GridItem
                            compact='auto'
                        >
                            {button}
                        </GridItem>
                    ))}
                </GridContainer>
            </GridItem>
        );
    }
}

export interface ILeftButtonsProps
{
    fullWidth?: boolean;
    children?: ReactNode;
}

export interface ILeftButtonsState { }
